import { useState, useEffect } from "react";
import { createSingletonHook } from "../helpers/singleton";
export const [usePrefs, PrefsProvider] = createSingletonHook(() => {
    var _a, _b, _c;
    const [lang, setLang] = useState(() => {
        const localLang = localStorage.getItem("lang");
        if (localLang && ["en", "hr", "rs"].includes(localLang)) {
            return localLang;
        }
        return "en";
    });
    const [theme, setTheme] = useState(localStorage.getItem("theme") === "dark" ? "dark" : "light");
    const [centralToken, setCentralToken] = useState((_a = localStorage.getItem("centralToken")) !== null && _a !== void 0 ? _a : null);
    const [tenantToken, setTenantToken] = useState((_b = localStorage.getItem("tenantToken")) !== null && _b !== void 0 ? _b : null);
    const [notificationPermission, setNotificationPermission] = useState("default");
    const [ticketStartTime, setTicketStartTime] = useState(sessionStorage.getItem("ticketStartTime"));
    const [ticketPhone, setTicketPhone] = useState(sessionStorage.getItem("ticketPhone"));
    const [sessionId, setSessionIdState] = useState((_c = sessionStorage.getItem("sessionId")) !== null && _c !== void 0 ? _c : sessionStorage.getItem("ticketSessionId"));
    const setSessionId = (value) => {
        const normalizedValue = (value === null || value === void 0 ? void 0 : value.trim()) || null;
        if (normalizedValue) {
            sessionStorage.setItem("sessionId", normalizedValue);
            sessionStorage.setItem("ticketSessionId", normalizedValue);
        }
        else {
            sessionStorage.removeItem("sessionId");
            sessionStorage.removeItem("ticketSessionId");
        }
        setSessionIdState(normalizedValue);
    };
    const getSessionId = () => {
        var _a;
        const normalizedValue = (_a = (sessionId ||
            sessionStorage.getItem("sessionId") ||
            sessionStorage.getItem("ticketSessionId"))) === null || _a === void 0 ? void 0 : _a.trim();
        return normalizedValue || undefined;
    };
    const [surveys, setSurveys] = useState(localStorage.getItem("surveys"));
    const [pageSize, setPageSize] = useState(
    // @ts-ignore
    localStorage.getItem("pageSize") !== null ? localStorage.getItem("pageSize") : "5");
    useEffect(() => {
        localStorage.setItem("lang", lang);
    }, [lang]);
    useEffect(() => {
        localStorage.setItem("theme", theme);
    }, [theme]);
    useEffect(() => {
        if (centralToken)
            localStorage.setItem("centralToken", centralToken);
        else
            localStorage.removeItem("centralToken");
    }, [centralToken]);
    useEffect(() => {
        if (tenantToken)
            localStorage.setItem("tenantToken", tenantToken);
        else
            localStorage.removeItem("tenantToken");
    }, [tenantToken]);
    useEffect(() => {
        if (ticketStartTime)
            sessionStorage.setItem("ticketStartTime", ticketStartTime);
        else
            sessionStorage.removeItem("ticketStartTime");
    }, [ticketStartTime]);
    useEffect(() => {
        if (ticketPhone)
            sessionStorage.setItem("ticketPhone", ticketPhone);
        else
            sessionStorage.removeItem("ticketPhone");
    }, [ticketPhone]);
    useEffect(() => {
        if (sessionId) {
            sessionStorage.setItem("sessionId", sessionId);
            sessionStorage.setItem("ticketSessionId", sessionId);
        }
        else {
            sessionStorage.removeItem("sessionId");
            sessionStorage.removeItem("ticketSessionId");
        }
    }, [sessionId]);
    useEffect(() => {
        if (surveys)
            localStorage.setItem("surveys", surveys);
        else
            localStorage.setItem("surveys", "");
    }, [surveys]);
    useEffect(() => {
        if (pageSize)
            localStorage.setItem("pageSize", pageSize);
        else
            localStorage.setItem("pageSize", "5");
    }, [pageSize]);
    return {
        lang,
        setLang,
        theme,
        setTheme,
        centralToken,
        setCentralToken,
        tenantToken,
        setTenantToken,
        notificationPermission,
        setNotificationPermission,
        ticketStartTime,
        setTicketStartTime,
        ticketPhone,
        setTicketPhone,
        sessionId,
        setSessionId,
        getSessionId,
        ticketSessionId: sessionId,
        setTicketSessionId: setSessionId,
        surveys,
        setSurveys,
        pageSize,
        setPageSize,
    };
});
